/* Bannière de consentement Kishi Kaisei.
   S'appuie sur l'API de confidentialité de Shopify : c'est elle qui bloque
   ensuite les pixels (Meta, TikTok, Klaviyo, Clarity) et qui transmet le
   consentement a Google. La bannière ne fait que recueillir le choix.
   Shopify n'autorise le blocage QUE par catégorie, jamais outil par outil :
   les lignes d'outils sont donc dépliables pour informer, pas cochables.
   Pour ajouter un outil plus tard (GA4, Google Ads), ajouter une ligne dans
   TOOLS ci-dessous : [nom, résumé, détail]. Rien d'autre a modifier. */
(function () {
  'use strict';

  var POLITIQUE = '/policies/privacy-policy';

  var TOOLS = {
    necessaire: [
      ['Shopify', 'Panier, compte et sécurité de la commande', 'Cookies techniques de la plateforme. Ils retiennent le contenu de votre panier, votre session et vos préférences de langue et de pays. Sans eux, la boutique ne fonctionne pas.'],
      ['Shopify Checkout', 'Paiement sécurisé', 'Sécurise le tunnel de paiement et protège la transaction contre la fraude au moment de la commande.'],
      ['Klarna', 'Paiement en trois fois', 'Affiche le paiement en trois fois sans frais sur les fiches produit, et sécurise la transaction si vous choisissez ce mode de paiement.'],
      ['Judge.me', 'Avis clients', 'Affiche les avis sur les fiches produit et retient si vous avez déjà déposé le vôtre, pour ne pas vous le redemander.'],
      ['Réseau de diffusion Shopify', 'Chargement et protection des pages', 'Sert les images et les pages depuis le serveur le plus proche de vous, et filtre les tentatives d’attaque sur la boutique.']
    ],
    mesure: [
      ['Shopify Analytics', 'Visites et ventes de la boutique', 'Compte les visites, les pages vues et les commandes. Les données restent chez Shopify et ne servent qu’à notre propre suivi.'],
      ['Microsoft Clarity', 'Où les visiteurs cliquent et décrochent', 'Enregistre le déroulé de votre visite : mouvements, clics, zones où vous vous arrêtez. Nous nous en servons pour repérer ce qui bloque sur le site. Il alimente aussi l’assistant du site.']
    ],
    publicite: [
      ['Meta Pixel', 'Visites venues d’Instagram et de Facebook', 'Signale à Meta qu’une visite a eu lieu et ce que vous avez regardé. Sert à mesurer nos publicités Instagram et Facebook, et à éviter de vous montrer une publicité pour un couteau que vous avez déjà acheté.'],
      ['TikTok Pixel', 'Visites venues de TikTok', 'Même fonction que le pixel Meta, pour nos publicités diffusées sur TikTok.'],
      ['Klaviyo', 'Emails adaptés à votre navigation', 'Relie votre navigation à votre adresse email si vous êtes inscrit à notre liste, pour adapter le contenu de nos emails et vous rappeler un panier oublié.']
    ]
  };

  var state = { step: 0, mesure: false, publicite: false };
  var root = null;

  /* Shopify ne conserve pas toujours le choix d'une page a l'autre : la banniere
     revenait a chaque page. On garde donc le choix nous-memes, six mois au plus
     comme le recommande la CNIL, et on le repose dans l'API Shopify a chaque
     chargement pour que les pixels soient bloques ou autorises correctement. */
  var CLE = 'kk_consent_v1';
  var DUREE = 182 * 24 * 60 * 60 * 1000;

  function lire() {
    try {
      var brut = window.localStorage.getItem(CLE);
      if (!brut) { return null; }
      var o = JSON.parse(brut);
      if (!o || typeof o.date !== 'number') { return null; }
      if (Date.now() - o.date > DUREE) { window.localStorage.removeItem(CLE); return null; }
      return o;
    } catch (e) { return null; }
  }

  function ecrire(mesure, pub) {
    try {
      window.localStorage.setItem(CLE, JSON.stringify({
        mesure: !!mesure, publicite: !!pub, date: Date.now()
      }));
    } catch (e) {}
  }

  function poser(mesure, pub, apres) {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && api.setTrackingConsent) {
      api.setTrackingConsent({
        analytics: !!mesure,
        preferences: !!mesure,
        marketing: !!pub,
        sale_of_data: !!pub
      }, apres || function () {});
    } else if (apres) { apres(); }
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function toolList(items) {
    var html = '<div class="kk-ck-tools">';
    for (var i = 0; i < items.length; i++) {
      html +=
        '<div class="kk-ck-tool">' +
        '<button type="button" class="kk-ck-tool__head" aria-expanded="false">' +
        '<span class="kk-ck-tool__name">' + esc(items[i][0]) + '</span>' +
        '<span class="kk-ck-tool__short">' + esc(items[i][1]) + '</span>' +
        '<span class="kk-ck-tool__plus" aria-hidden="true">+</span>' +
        '</button>' +
        '<div class="kk-ck-tool__body">' + esc(items[i][2]) + '</div>' +
        '</div>';
    }
    return html + '</div><a class="kk-ck-link" href="' + POLITIQUE + '">Lire notre politique de confidentialité</a>';
  }

  var SCREENS = [
    function () {
      return {
        body:
          '<p class="kk-ck-over">Avant d’entrer dans l’atelier,</p>' +
          '<h2 class="kk-ck-title">parlons franchement.</h2>' +
          '<p class="kk-ck-text">Vous êtes ici pour des couteaux, pas pour des cookies. On ne va donc pas vous raconter d’histoires. Certains servent à faire fonctionner la boutique, d’autres à comprendre ce qui vous intéresse. Vous décidez des seconds.</p>' +
          '<p class="kk-ck-note">Vous pourrez revenir sur vos choix à tout moment via le lien « Préférences de cookies » en bas de page.</p>',
        left: 'Je choisis',
        right: 'Tout accepter',
        onLeft: function () { go(1); },
        onRight: function () { save(true, true); }
      };
    },
    function () {
      return {
        step: '1 sur 3',
        body:
          '<h2 class="kk-ck-title">Le strict nécessaire</h2>' +
          '<p class="kk-ck-sub">Ceux-là ne se discutent pas</p>' +
          '<p class="kk-ck-text">Ils gardent votre panier en mémoire, sécurisent votre paiement et retiennent votre langue. Sans eux, la boutique ne fonctionne pas. Ils ne nous apprennent rien sur vous.</p>' +
          toolList(TOOLS.necessaire),
        left: 'Retour',
        right: 'Suivant',
        onLeft: function () { go(0); },
        onRight: function () { go(2); }
      };
    },
    function () {
      return {
        step: '2 sur 3',
        body:
          '<h2 class="kk-ck-title">Ce qu’on cherche à comprendre</h2>' +
          '<p class="kk-ck-sub">Quelles pages vous aident vraiment à choisir</p>' +
          '<p class="kk-ck-text">Nous sommes une jeune maison. Savoir quelles fiches vous lisez, et où vous décrochez, nous dit quoi améliorer. Rien ne se déclenche sans votre accord.</p>' +
          '<label class="kk-ck-switch"><span>Autoriser la mesure d’audience</span>' +
          '<input type="checkbox" data-kk-cat="mesure"' + (state.mesure ? ' checked' : '') + '></label>' +
          toolList(TOOLS.mesure),
        left: 'Retour',
        right: 'Suivant',
        onLeft: function () { go(1); },
        onRight: function () { go(3); }
      };
    },
    function () {
      return {
        step: '3 sur 3',
        body:
          '<h2 class="kk-ck-title">Là où vous nous avez trouvés</h2>' +
          '<p class="kk-ck-sub">Instagram, TikTok, Google</p>' +
          '<p class="kk-ck-text">Ces cookies nous disent si une vidéo vous a amené jusqu’ici. Ils nous évitent aussi de payer pour vous montrer une publicité alors que vous avez déjà commandé.</p>' +
          '<label class="kk-ck-switch"><span>Autoriser la mesure publicitaire</span>' +
          '<input type="checkbox" data-kk-cat="publicite"' + (state.publicite ? ' checked' : '') + '></label>' +
          toolList(TOOLS.publicite),
        left: 'Retour',
        right: 'Valider mes choix',
        onLeft: function () { go(2); },
        onRight: function () { save(state.mesure, state.publicite); }
      };
    }
  ];

  function render() {
    var s = SCREENS[state.step]();
    var card = root.querySelector('.kk-ck-card');
    card.innerHTML =
      '<div class="kk-ck-top"><button type="button" class="kk-ck-refuse">Continuer sans accepter</button></div>' +
      (s.step ? '<p class="kk-ck-steps">' + s.step + '</p>' : '') +
      '<div class="kk-ck-body">' + s.body + '</div>' +
      '<div class="kk-ck-foot">' +
      '<button type="button" class="kk-ck-btn kk-ck-btn--ghost">' + s.left + '</button>' +
      '<button type="button" class="kk-ck-btn kk-ck-btn--solid">' + s.right + '</button>' +
      '</div>';
    card.querySelector('.kk-ck-refuse').onclick = function () { save(false, false); };
    card.querySelector('.kk-ck-btn--ghost').onclick = s.onLeft;
    card.querySelector('.kk-ck-btn--solid').onclick = s.onRight;
    var box = card.querySelector('[data-kk-cat]');
    if (box) {
      box.onchange = function () { state[box.getAttribute('data-kk-cat')] = box.checked; };
    }
    var heads = card.querySelectorAll('.kk-ck-tool__head');
    for (var i = 0; i < heads.length; i++) {
      heads[i].onclick = function () {
        var row = this.parentNode;
        var open = row.classList.toggle('is-open');
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
    }
  }

  function go(i) { state.step = i; render(); }

  function open() {
    if (!root) build();
    var garde = lire();
    if (garde) {
      state.mesure = !!garde.mesure;
      state.publicite = !!garde.publicite;
    } else {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && api.currentVisitorConsent) {
        var c = api.currentVisitorConsent();
        state.mesure = c.analytics === 'yes';
        state.publicite = c.marketing === 'yes';
      }
    }
    state.step = 0;
    render();
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (root) root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function save(mesure, pub) {
    ecrire(mesure, pub);
    close();
    poser(mesure, pub);
  }

  function build() {
    root = document.createElement('div');
    root.className = 'kk-ck-overlay';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Choix des cookies');
    root.innerHTML = '<div class="kk-ck-card"></div>';
    document.body.appendChild(root);
  }

  function addFooterLink() {
    if (document.querySelector('.kk-cookie-prefs, .kk-ck-prefs-auto')) return;
    var foot = document.querySelector('footer');
    if (!foot) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kk-ck-prefs-auto';
    b.textContent = 'Préférences de cookies';
    b.onclick = open;
    foot.appendChild(b);
  }

  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.kk-cookie-prefs, [data-kk-cookies], a[href="#cookies"]');
      if (t) { e.preventDefault(); open(); }
    });
  }

  /* Sur la page d'accueil, on laisse l'animation d'ouverture se terminer,
     puis on attend encore une seconde avant d'afficher la bannière. */
  function ms(v) {
    var max = 0;
    var parts = String(v || '').split(',');
    for (var i = 0; i < parts.length; i++) {
      var n = parseFloat(parts[i]) || 0;
      if (parts[i].indexOf('ms') > -1) { n = n / 1000; }
      if (n > max) { max = n; }
    }
    return max * 1000;
  }

  function afterIntro(cb) {
    var hero = document.querySelector('.hero');
    var els = hero ? hero.querySelectorAll('.reveal') : [];
    if (!els.length) { cb(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      var pret = true;
      for (var i = 0; i < els.length; i++) {
        if (!els[i].classList.contains('in')) { pret = false; }
      }
      if (!pret && ++tries < 30) { return; }
      clearInterval(timer);
      var fin = 0;
      for (var j = 0; j < els.length; j++) {
        var st = getComputedStyle(els[j]);
        var t = ms(st.transitionDelay) + ms(st.transitionDuration);
        if (t > fin) { fin = t; }
      }
      setTimeout(cb, fin + 1000);
    }, 100);
  }

  function start() {
    bindTriggers();
    addFooterLink();
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return;
      var garde = lire();
      if (garde) { poser(garde.mesure, garde.publicite); return; }
      if (window.Shopify.customerPrivacy.shouldShowBanner()) { afterIntro(open); }
    });
  }

  window.kkCookies = { open: open, close: close };

  if (window.Shopify && window.Shopify.loadFeatures) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();
